import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './slices/authSlice';
import equipmentReducer from './slices/equipmentsSlice';
import eventsReducer from './slices/eventsSlice';
import myselfReducer from './slices/myselfSlice';
import reservationReducer from './slices/reservationSlice';
import userReducer from './slices/userSlice';

export default combineReducers({
  auth: authReducer,
  equipments: equipmentReducer,
  reservations: reservationReducer,
  users: userReducer,
  myself: myselfReducer,
  events: eventsReducer,
});
